import {
  Filter,
  FilterCreateInput,
  FilterUpdateInput
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function listFilters(): Promise<Filter[]> {
  return httpClient.get<Filter[]>('/protected/filters');
}

export async function listTabFilters(): Promise<Filter[]> {
  return httpClient.get<Filter[]>('/protected/filters', { params: { isTab: 'true' } });
}

export async function getFilter(id: number): Promise<Filter> {
  return httpClient.get<Filter>(`/protected/filters/${id}`);
}

export async function createFilter(data: FilterCreateInput): Promise<Filter> {
  return httpClient.post<Filter, FilterCreateInput>('/protected/filters', data);
}

export async function updateFilter(id: number, data: FilterUpdateInput): Promise<Filter> {
  return httpClient.patch<Filter, FilterUpdateInput>(`/protected/filters/${id}`, data);
}

export async function deleteFilter(id: number): Promise<void> {
  return httpClient.delete<void>(`/protected/filters/${id}`);
}

export interface FilterReorderPayload {
  tabIds: number[];
  filterIds: number[];
}

export async function reorderFilters(payload: FilterReorderPayload): Promise<void> {
  return httpClient.post<void, FilterReorderPayload>('/protected/filters/reorder', payload);
}
